import { get, post } from './client';
import type {
  AuthResult,
  AuthUser,
  PaymentMethodView,
  StoreSettings,
} from '@/types/api';

/**
 * Servis katmanı: HTTP yolları TEK yerde. Component'ler string URL yazmaz.
 * Faz 0'da yalnızca gerçekten çalışan uçlar tanımlıdır — sahte uç yoktur.
 */

export const settingsApi = {
  getPublic: () => get<StoreSettings>('/settings/public'),
};

export const authApi = {
  login: (payload: { email: string; password: string }) =>
    post<AuthResult>('/auth/login', payload),
  register: (payload: {
    email: string;
    password: string;
    name: string;
    phone?: string;
  }) => post<AuthResult>('/auth/register', payload),
  logout: (refreshToken: string) =>
    post<{ revoked: boolean }>('/auth/logout', { refreshToken }),
  me: () => get<AuthUser & { createdAt: string }>('/auth/me'),
};

export const paymentsApi = {
  listMethods: () => get<PaymentMethodView[]>('/payment-methods'),
};

export const healthApi = {
  check: () =>
    get<{
      status: 'ok' | 'degraded';
      database: 'up' | 'down';
      latencyMs: number;
      timestamp: string;
    }>('/health'),
};
